"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = FormButtonSubmit;
exports.SubmitHint = void 0;

var _react = _interopRequireDefault(require("react"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ButtonNorma = require("../ButtonNorma");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react["default"].createElement;

var SubmitHint = _styledComponents["default"].span.withConfig({
  displayName: "FormButtonSubmit__SubmitHint",
  componentId: "l536hp-0"
})(["display:block;", ";margin:16px 0 0;", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.typography.bodyCaption;
}, function (_ref2) {
  var $formTheme = _ref2.$formTheme;

  switch ($formTheme) {
    case 'dark':
      return (0, _styledComponents.css)(["color:var(--colors-lynch);"]);

    case 'light':
    default:
      return (0, _styledComponents.css)(["color:var(--colors-mischka);"]);
  }
});

exports.SubmitHint = SubmitHint;

function FormButtonSubmit(_ref3) {
  var formTheme = _ref3.formTheme,
      hasSubmitHint = _ref3.hasSubmitHint,
      props = (0, _objectWithoutProperties2["default"])(_ref3, ["formTheme", "hasSubmitHint"]);
  return __jsx(_react["default"].Fragment, null, __jsx(_ButtonNorma.Button, (0, _extends2["default"])({
    type: "submit",
    size: "lg",
    tone: formTheme === 'dark' ? 'primary' : 'inverted',
    shadow: formTheme === 'dark'
  }, props)), hasSubmitHint && __jsx(SubmitHint, {
    $formTheme: formTheme,
    "aria-hidden": "true"
  }, "or press enter"));
}

FormButtonSubmit.defaultProps = {
  hasSubmitHint: false,
  formTheme: 'dark'
};